import * as React from "react";
import { useAuthStyles } from "./styles";

export default function FormError({ message }) {
	const styles = useAuthStyles();

	if (!message) {
		return null;
	}

	return (
		<p className={styles.formError} role="alert">
			{message}
		</p>
	);
}
